module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Adjust-b8549d7d5b51a4ca87d561c24cf4514d.svg";